import { render, staticRenderFns } from "./holiday-time-content.vue?vue&type=template&id=6820c00d&scoped=true&"
import script from "./holiday-time-content.vue?vue&type=script&lang=ts&"
export * from "./holiday-time-content.vue?vue&type=script&lang=ts&"
import style0 from "./holiday-time-content.vue?vue&type=style&index=0&id=6820c00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820c00d",
  null
  
)

export default component.exports